import { forwardRef, useState, useEffect, useRef } from "react";
import "../styles/Hero.css";
import Hourscount from "../components/Hourscount";
import heroVideo from "../assets/videos/hero_bg.mp4";
import backgroundMusic from "../assets/audio/bg_audio.mp3";
import UBuy_presents from "../assets/sponsors_img/Ubuy_presents_logo.jpg"

const Hero = forwardRef((props, ref) => {
  const [showHero, setShowHero] = useState(false);
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHero(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const togglePlayPause = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div ref={ref} className={`hero-container ${showHero ? "fade-in" : "hidden"}`}>
      <video className="video-background" autoPlay loop muted>
        <source className="video_cont" src={heroVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="hero">
        <h2 className="hero-presents">UBuy Presents</h2>
        <h1 className="hero-title">Innovastra</h1>
        <h3 className="hero-para">
          <strong className="hero-para1">24hrs Hackathon</strong> • Unleash The{" "}
          <strong className="hero-para1">Power</strong> Of{" "}
          <strong className="hero-para1">Technology</strong>
        </h3>

        <div className="tags-container">
          <a href="/certificates" className="tag">Get Certificates</a>
        </div>

        <div className="timer">
          <div className="countdet">
            <Hourscount className="count" eventDate="2025-02-28T11:00:00" />
          </div>
        </div>
      </div>

      <div className="music-player">
        <audio ref={audioRef} src={backgroundMusic} />
        <button class="aud-button" onClick={togglePlayPause}>
        <div class="aud-button-overlay"></div>
        <span>
        {isPlaying ? "| |" : "▷"} </span>
        </button>
      </div>
    </div>
  );
});

export default Hero;
